import { Schema } from "effect";

export const MCP_HTTP_PATH = "/mcp";
export const MCP_PROTOCOL_VERSIONS = ["2025-11-25", "2025-06-18", "2025-03-26", "2024-11-05"] as const;
export const MCP_MAX_BODY_BYTES = 8 * 1024 * 1024;
export const MCP_MAX_BATCH_REQUESTS = 100;
export const MCP_MAX_BATCH_CONCURRENCY = 4;

export const McpJsonRpcId = /* @__PURE__ */ (() => Schema.NullOr(Schema.Union([Schema.String, Schema.Number])))();
export type McpJsonRpcId = typeof McpJsonRpcId.Type;
export const McpJsonRpcRequest = /* @__PURE__ */ (() => Schema.Struct({
  jsonrpc: Schema.Literal("2.0"),
  id: Schema.optionalKey(McpJsonRpcId),
  method: Schema.String,
  // Each selected operation owns its parameter decoder and error precedence.
  params: Schema.optionalKey(Schema.Unknown)
}))();
export type McpJsonRpcRequest = typeof McpJsonRpcRequest.Type;

export const McpInitializeParams = /* @__PURE__ */ (() => Schema.Struct({
  protocolVersion: Schema.String,
  capabilities: Schema.Record(Schema.String, Schema.Unknown),
  clientInfo: Schema.Struct({ name: Schema.String, version: Schema.String })
}))();

export const McpJsonRpcError = /* @__PURE__ */ (() => Schema.Struct({
  jsonrpc: Schema.Literal("2.0"),
  id: McpJsonRpcId,
  error: Schema.Struct({
    code: Schema.Number,
    message: Schema.String,
    data: Schema.optionalKey(Schema.Json)
  })
}))();
export type McpJsonRpcError = typeof McpJsonRpcError.Type;
export const McpJsonRpcSuccess = /* @__PURE__ */ (() => Schema.Struct({
  jsonrpc: Schema.Literal("2.0"), id: McpJsonRpcId, result: Schema.Json
}))();
export const McpJsonRpcResponse = /* @__PURE__ */ (() => Schema.Union([McpJsonRpcSuccess, McpJsonRpcError]))();
export type McpJsonRpcResponse = typeof McpJsonRpcResponse.Type;
export const McpJsonRpcEnvelope = /* @__PURE__ */ (() => Schema.Union([McpJsonRpcResponse, Schema.Array(McpJsonRpcResponse)]))();

